import { render } from "./board_detail.vue?vue&type=template&id=ac09cfc6&scoped=true"
import script from "./board_detail.vue?vue&type=script&lang=js"
export * from "./board_detail.vue?vue&type=script&lang=js"

import "./board_detail.vue?vue&type=style&index=0&id=ac09cfc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac09cfc6"]])

export default __exports__